const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const buildLockedTimeline = () =>
  MONTH_NAMES.map((month_name, index) => ({
    month: index + 1,
    month_name,
    chargeback_rate: 0,
    chargeback_count: 0,
    transaction_count: 0,
    three_ds_usage_rate: null,
    status: "no_status",
    icon: "lock",
  }));
